export default {
  GET_COUPON_TICKET: "/api/v1/coupon-ticket",
  GET_COUPON_TICKET_CONFIRM: "/api/v1/coupon-ticket/confirm",

  GET_ORDER_COUPON_AVAILABLE: "/api/v1/order/coupon/available",
  GET_ORDER_COUPON_MANUAL_VALIDATE: "/api/v1/order/coupon-manual/validate",
  GET_ORDER_COUPON_MANUAL_USED: "/api/v1/order/coupon-manual/used",

  GET_ORDER_COUPON_INCHEON_AVAILABLE: "/api/v1/order/coupon-incheon/available",
};
